import React from "react";
import { VerifyEmailConfirmed } from "../../components/CreateAccountVerifyEmail/VerifyEmailConfirmed";

const VerifyEmailConfirmedPage = (): React.ReactElement => (
  <VerifyEmailConfirmed />
);

export default VerifyEmailConfirmedPage;
